import { useUser } from '../../contexts/userContext';
import { isAdmin } from '../../utils';
import { Navigate } from 'react-router';

export default function RequireAdmin({ children }: { children: JSX.Element }) {
	const user = useUser();

	return isAdmin(user) ? children : <Navigate to="/" replace />;
}
